import React, {Component} from 'react';
import {connect} from "react-redux";
import * as actionCreator from "../../../../store/Action/index";
import './style.css'
import * as common from '../../../../const/Common/CommonFunc';

import {Button, Card, CardBody,CardHeader, Col, Row} from 'reactstrap';
import LabelInput from "../../../../components/Input/Input/TxtLbl";
import {MDBDataTable} from 'mdbreact'
import {Button as SementicBtn, Icon, Form} from 'semantic-ui-react'
import swal from "sweetalert";

import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
// import Lbl from "../../../../components/Label/Lbl";
import DrpDwn from "../../../../components/Dropdown/Dropdown/DrpDwn";
import $ from "jquery";

import Cookies from "js-cookie";
import axiosTags from "../../../../axios/axios_tag";
// import GoogleLocation from "../../../../components/GoogleLocation/GoogleLocation";
// import {SketchPicker} from "react-color";
import apiConfig from "../../../../axios/axios_api_services";
import * as validator from "../../../../util/Validator";
import uuid from "uuid";

class App extends Component {

  state = {
    branch_list: [],
    branch_id: '',
    building_name: '',
    building_code: '',
    building_location: null,
    building_status: true,

    floor_name: '',
    floor_level: '',
    floor_color: '#ffffff',
    floor_status: true,

    floor_list: []
  };

  buttonClick = (event, type, state) => {

    let floor_name = this.state.floor_name;
    let floor_level = this.state.floor_level;
    let floor_status = this.state.floor_status;
    let floor_color = common.getRandomColor();

    switch (type) {
      case 'addFloor':

        let floor_list = this.state.floor_list;
        let condition = false;
        let isColor = false;

        if (floor_name.trim() === "" || floor_level === "") {
          common.notifyMessage("Please enter floor details")
        } else {

          if (floor_list.length !== 0) {
            floor_list.map((floor, index) => {
              if (floor.description === floor_name.trim() && floor.level === floor_level) {
                condition = true;
              }
              if (floor.floorColour === floor_color) {
                isColor = true
              }
            })
          }
          if (!condition) {
            if (!isColor) {
              const obj = {
                description: floor_name.trim(),
                level: floor_level,
                floorColour: floor_color,
                status: floor_status ? "AVAILABLE" : "UNAVAILABLE"
              };
              floor_list.push(obj);
              this.setState({floor_list: floor_list, floor_name: "", floor_level: ""});
            } else {
              // common.notifyMessage("Please change floor color - ("+floor_color+")")
              this.buttonClick(event, type, state);
            }
          } else {
            common.notifyMessage("Already assign this floor name and level")
          }
        }

        break;
      case 'createLocation':
        let isResult = this.checkBuildingValidation();
        if (isResult) {
          let isResult = this.checkFloorValidation();
          if (isResult) {
            swal({
              title: "Are you sure do you want to create building?",
              icon: are_you_sure_icon,
              closeOnClickOutside: false,
              buttons: {
                cancel: 'Cancel',
                dangerMode: {
                  text: "Yes",
                  value: "action",
                  className: "okay-btn"
                }
              },
            }).then((value) => {

              switch (value) {
                case "action":
                  this.sendToBackend(state);
                  break;
                default:
                  break;
              }
            });
          }
        }

        break;
      default:
        break;
    }
  };

  sendToBackend = (state) => {
    let name = this.state.building_name.trim();
    let code = uuid();
    let location = this.state.building_location;
    let status = this.state.building_status ? "AVAILABLE" : "UNAVAILABLE";
    let branchId = this.state.branch_id;

    const obj = {
      "name": name,
      "location": location,
      "code": code,
      "status": status,
      "floors": this.state.floor_list
    };

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);

    axiosTags.put(apiConfig.CORPORATE_BRANCH_BUILDING({
      corporateId: this.props.usr_obj.corporateId,
      branchId: branchId
    }), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert(response.data.message, 0);
          this.props.refreshData();
          this.clearFeilds();
          //  dashboard single type
          this.props.addTagsDashboardSingle("buildingsCount", response.data.success ? 1 : 0);

          if (state === "CLOSE" && this.props.parent) {
            this.props.closeModal();
          }
          //  --------
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackend(state)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  clearFeilds = () => {
    this.setState({
      building_name: '',
      building_code: '',
      building_location: null,
      building_status: true,
      floor_name: '',
      floor_level: '',
      floor_color: '#ffffff',
      floor_status: true,
      floor_list: []
    })
  };

  checkFloorValidation = () => {
    if (this.state.floor_list.length !== 0) {
      return true;
    } else {
      common.notifyMessage("Please create floor details");
      return false;
    }
  };

  checkBuildingValidation = () => {
    if (this.state.building_name.trim() === '' || this.state.branch_id === '') {
      common.notifyMessage("Please select branch and building details");
      return false;
    } else {
      return true;
    }
  };

  deleteFloor = (index, name) => {
    swal({
      title: "Do you want to remove " + name + "?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Remove",
          value: "action",
          className: "remove-btn"
        }
      }
    })
      .then((value) => {
        switch (value) {
          case "action":
            let data = this.state.floor_list;
            data.splice(index, 1);
            this.setState({floor_list: data});
            break;
          default:
        }
      });

  };
  updateFloor = (e, index) => {

  };
  dropDownChange = name => (event, {value}) => {
    switch (name) {
      case 'branch':
        this.setState({
          branch_id: value
        });
        break;
      default:
        break;
    }
  };
  getAllBranch = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);
    axiosTags.get(apiConfig.CORPORATE_BRANCH(this.props.usr_obj.corporateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            branch_list: response.data.branchList,
          })
        } else {
          this.setState({
            branch_list: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllBranch()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
        if (this.props.tempBranchId !== 0) {
          this.setState({branch_id: this.props.tempBranchId})
        }
      });
  };
  handleChange = name => event => {
    let value = event.target.value;
    if (name === "floor_level") {
      let isValid = validator.isOnlyNumbersValdator(value);
      if (!isValid && value !== "") return;
    }

    this.setState({
      [name]: value
    });
  };
  handleChange_ = building_location => {
    this.setState({building_location});
  };
  handleSelect_ = building_location => {
    this.setState({building_location});
  };
  addressHandler_ = (building_location) => {
    this.setState({building_location});
  };
  handleChangeComplete = (color) => {
    this.setState({floor_color: color.hex});
  };

  componentDidMount() {
    $('input').attr('autocomplete', 'off');
    this.getAllBranch();
  }

  render() {
    let {branch_list} = this.state;
    let branch_options = [];
    if (branch_list.length !== 0) {
      branch_list.map((branch, index) => {

        const obj = {
          key: index,
          text: branch.name,
          value: branch.branchId
        };
        branch_options.push(obj)
      })
    }

    const rows = [];
    if (this.state.floor_list.length !== 0) {
      this.state.floor_list.map((row, index) => {
        rows.push(
          {
            desc: row.description,
            level: row.level,
            // status: row.status,
            // color: row.floorColour,
            action:
              <div>
                {/*<SementicBtn circular icon='edit' onClick={e => this.updateFloor(e, index)}/>*/}
                <SementicBtn className="cus-btn" circular icon='trash alternate'
                             onClick={() => this.deleteFloor(index, row.description)}/>
              </div>
          }
        )
      });
    }

    let columns = this.props.table_data.new_floor_columns;
    let table_data = {columns, rows};

    return (
      <div>
        <Card>
          <CardHeader>Add Building Details</CardHeader>
          <CardBody>
            {/*<div className={"add-building-wrapper card-header"}> Add Building Details</div>*/}
            <Row>
              <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
                <Row>
                  <Col lg={6}>
                    <Form>
                      <Form.Group widths='equal'>
                        <DrpDwn
                          required
                          tagText={"Choose Branch"}
                          placeholder={"Branch"}
                          options={branch_options}
                          value={this.state.branch_id}
                          onChange={this.dropDownChange('branch')}
                        />
                      </Form.Group>
                    </Form>
                  </Col>
                  <Col lg={6}>
                    <Form>
                      <Form.Group widths='equal'>
                        <LabelInput
                          required
                          tagText={"Building Name"}
                          placeholder={"Building Name"}
                          value={this.state.building_name}
                          onChange={this.handleChange('building_name')}
                        />
                      </Form.Group>
                    </Form>
                  </Col>

                  {/*<Col lg={6}>*/}
                  {/*<Form>*/}

                  {/*<Row>*/}
                  {/*<Col sm={12}>*/}
                  {/*<Lbl marginTop={"0px"} required>Location</Lbl>*/}
                  {/*<GoogleLocation placeholder={"Select location"} location={this.state.building_location}*/}
                  {/*handleChange_={this.handleChange_} handleSelect_={this.handleSelect_}*/}
                  {/*addressHandler_={this.addressHandler_}/>*/}

                  {/*</Col>*/}
                  {/*</Row>*/}
                  {/*<br/>*/}
                  {/*/!*<Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}*!/*/}
                  {/*/!*checked={this.state.building_status} onChange={()=>this.setState({ building_status: !this.state.building_status })} toggle*!/*/}
                  {/*/!*label={this.state.building_status ? 'Available Building' : 'Unavailable Building'}/>*!/*/}
                  {/*</Form>*/}
                  {/*</Col>*/}
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card className={"none-margin"}>
          <CardHeader>Add Floors</CardHeader>
          <CardBody>

            {/*<div className={"add-floors-wrapper card-header"}> Add Floors</div>*/}

            <Row>
              <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
                <Row>
                  <Col lg={7}>
                    <Form>
                      <Form.Group widths='equal'>
                        <LabelInput
                          required
                          tagText={"Floor Name"}
                          placeholder={"Floor Name"}
                          value={this.state.floor_name}
                          onChange={this.handleChange('floor_name')}
                        />
                      </Form.Group>
                      {/*<Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}*/}
                      {/*checked={this.state.floor_status} onChange={()=>this.setState({ floor_status: !this.state.floor_status })} toggle*/}
                      {/*label={this.state.floor_status ? 'Available Floor' : 'Unavailable Floor'}/>*/}
                    </Form>
                  </Col>
                  <Col lg={5}>
                    <Form>
                      <Form.Group widths='equal'>
                        <LabelInput
                          required
                          tagText={"Level"}
                          placeholder={"Floor Level"}
                          value={this.state.floor_level}
                          onChange={this.handleChange('floor_level')}
                        />
                      </Form.Group>
                    </Form>
                    <br/>
                    {/*<SketchPicker*/}
                    {/*color={ this.state.floor_color }*/}
                    {/*onChangeComplete={ this.handleChangeComplete }*/}
                    {/*/>*/}

                    <Row>
                      <Col className="marginTop_ align-right" xs={12} sm={12} md={12} lg={12}>
                        <SementicBtn icon style={{marginBottom: '7px', marginRight: 0}}
                                     onClick={e => this.buttonClick(e, 'addFloor')}>
                          <Icon name='angle down' className="animated infinite bounce delay-2s"/>
                          Add Floor to the Building
                        </SementicBtn>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>

            </Row>

            {
              this.state.floor_list.length !== 0 ?
                <Row>
                  <Col lg="12">
                    <MDBDataTable
                      entries={8}
                      responsive
                      responsiveSm
                      responsiveMd
                      responsiveLg
                      responsiveXl
                      bordered
                      hover
                      data={table_data}/>
                  </Col>
                </Row> : null
            }
            <center>
              {
                this.state.floor_list.length !== 0 ?
                  <div>
                    <br/>
                    <Button
                      className="submit-btn mr-2"
                      onClick={e => this.buttonClick(e, 'createLocation', "ADD")}
                    >Create And Add new</Button>
                    <Button
                      className="submit-btn"
                      onClick={e => this.buttonClick(e, 'createLocation', "CLOSE")}
                    >Create And Close</Button>
                  </div>
                  : null
              }
            </center>
          </CardBody>
        </Card>
      </div>
    );
  }
}


const mapStateToProps = (state) => ({
  table_data: state.COPLocationReducer.table_data,
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    addFloor: (data) => dispatch(actionCreator.addFloor(data)),
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // dashboard single value handler
    addTagsDashboardSingle: (type, data) => dispatch(actionCreator.addTagsDashboardSingle(type, data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
